import {
  v2_selectSingleChoiceConfigurationPropertyValue,
  v2_useAddConfigurationToCart,
  v2_useCart,
  v2_useProduct,
} from '@crocodille/common';
import { useAppLayoutState } from '@layouts/app-layout/app-layout';
import { useCallback, useEffect, useRef } from 'react';
import MenuIncentive from '../menu-incentive/menu-incentive';

export interface MenuIncentiveModalProps {
  productSlug: string;
  onClose: () => void;
}

function MenuIncentiveModal({ productSlug, onClose }: MenuIncentiveModalProps) {
  const { data: cart } = v2_useCart();

  const {
    data: product,
    configurationValues,
    filteredConfiguration,
    setSingleChoiceProperty,
    clearConfiguration,
  } = v2_useProduct(productSlug);

  const { addConfigurationToCart, isMutating: addingToCart } =
    v2_useAddConfigurationToCart({
      product,
      filteredConfiguration,
      configurationValues,
    });

  const menuIncentive = filteredConfiguration?.find(
    (c) => c.role === 'menu_incentive',
  );
  const menuIncentiveValue = menuIncentive
    ? v2_selectSingleChoiceConfigurationPropertyValue(
        configurationValues,
        menuIncentive.id,
      )
    : undefined;

  const { toggleCartOpen } = useAppLayoutState();

  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;
  const addingToCartRef = useRef(addingToCart);
  addingToCartRef.current = addingToCart;
  const clearConfigurationRef = useRef(clearConfiguration);
  clearConfigurationRef.current = clearConfiguration;
  const addConfigurationToCartRef = useRef(addConfigurationToCart);
  addConfigurationToCartRef.current = addConfigurationToCart;

  const addToCart = useCallback(async () => {
    const added = await addConfigurationToCartRef.current();
    if (added) {
      clearConfigurationRef.current();
      toggleCartOpen(true);
      onCloseRef.current();
    }
  }, [toggleCartOpen]);

  useEffect(() => {
    if (!addingToCartRef.current && menuIncentiveValue) {
      addToCart();
    }
  }, [addToCart, menuIncentiveValue]);

  return (
    <MenuIncentive
      open={menuIncentive != null}
      incentive={menuIncentive}
      incentiveValue={menuIncentiveValue}
      showPrices={cart != null}
      onChoice={async (code) => {
        if (menuIncentive) {
          setSingleChoiceProperty(menuIncentive.id, code);
        }
      }}
      onClose={onClose}
    />
  );
}

export default MenuIncentiveModal;
